// @ts-strict-ignore
import * as React from 'react';
import { useSelector } from 'react-redux';
import * as API from '../../api';
import { PredictReleaseVersionRequest } from '../../actions/app';
import { selectAuthCredentials, selectIsDemoInstance } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';

export interface UsePredictVersionProps {
    orgId: string;
    appId: string;
}

export interface UsePredictVersionReturn {
    predictVersion: (isHotfix: boolean) => Promise<string>;
    isLoading: boolean;
}

export const usePredictVersion = ({ orgId, appId }: UsePredictVersionProps): UsePredictVersionReturn => {
    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));
    const isDemoInstance = useSelector((state: RootState) => selectIsDemoInstance(state, orgId));

    const [isLoading, setIsLoading] = React.useState(false);

    const predictVersion = React.useCallback(
        async (isHotfix: boolean): Promise<string> => {
            setIsLoading(true);

            const request: PredictReleaseVersionRequest = {
                orgId,
                appId,
                isHotfix,
            };

            try {
                const version = await API.predictReleaseVersion(request, authCredentials);
                return version;
            } catch {
                // Fallback version for demo or error cases
                return isDemoInstance ? '1.3.0' : '1.5.0';
            } finally {
                setIsLoading(false);
            }
        },
        [orgId, appId, authCredentials, isDemoInstance],
    );

    return {
        predictVersion,
        isLoading,
    };
};
